import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createMembershipProfileComplementaryItem,
  deleteMembershipProfileComplementaryItem,
  updateMembershipProfileComplementaryItem,
} from '@store/membership/MembershipProfileComplementaryItemReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const MembershipProfileComplementaryItemForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector(
      (state) => state.membershipProfileComplementaryItem
    )

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            await dispatch(createMembershipProfileComplementaryItem(values))
            return true
          },
          update: async (values) => {
            await dispatch(updateMembershipProfileComplementaryItem(values))
            return true
          },
          delete: async (values) => {
            await dispatch(deleteMembershipProfileComplementaryItem(values))
            return true
          },
        }}
      />
    )
  }
)

MembershipProfileComplementaryItemForm.displayName =
  'MembershipProfileComplementaryItemForm'

export default MembershipProfileComplementaryItemForm
